import { useQuery } from "@tanstack/react-query";
import { reactQueryOptions } from "src/config/reactQuery.config";
import { useGetAccessPermission } from "src/hooks/useGetAccessPermission";
import { getPackageCategory } from "src/services/PackageCategory.service";
import { AccessResource, ActionType } from "src/types/accessControl";

export const useGetPackageCategory = () => {
  const isAllowedPackageCategory = useGetAccessPermission({
    resource: AccessResource["Master Data - Package Category"],
    action: ActionType["Read"],
  });
  return useQuery({
    ...reactQueryOptions,
    queryKey: ["package-category"],
    queryFn: () => getPackageCategory(),
    enabled: isAllowedPackageCategory,
  });
};
